module.exports = __webpack_public_path__ + "img/9.149ac56b.jpg";